<template>
    <div class="home">
        <v-row justify="center">
            <v-col sm="12" md="6" lg="6" xl="4">
                <v-card>
                    <v-card-title class="headline">Calypso Anemometer</v-card-title>
                    <v-card-text>
                        <v-alert v-if="this.Navigator.bluetooth === undefined">Bluetooth ist nicht verfügbar</v-alert>
                        <v-list>
                            <v-list-item v-if="device !== undefined">
                                <v-list-item-avatar :color="connected ? 'success' : 'error'"></v-list-item-avatar>
                                <v-list-item-title>{{ device.name }}</v-list-item-title>
                                <v-list-item-action>
                                    <v-progress-circular indeterminate v-if="connecting === true"></v-progress-circular>
                                    <v-btn v-if="connecting === false && connected === false" @click="connect()">
                                        Verbinden
                                    </v-btn>
                                    <v-btn v-if="connecting === false && connected === true" @click="disconnect()">
                                        Trennen
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                        <v-row>
                            <v-col v-if="connected === true">
                                <v-select :items="[1,2,3,4,5,6,7,8,9,10]" v-model="valuesToCalculate" label="Messungen"></v-select>
                            </v-col>
                            <v-col v-if="connected === true">
                                <v-select :items="[1, 5, 10, 15, 20, 30, 60]" v-model="intervalTime" label="Intervall [s]"></v-select>
                            </v-col>
                            <v-col v-if="connected === true">
                                <v-btn v-if="connected === true && timer === undefined" @click="startTracking()">Start Tracking</v-btn>
                                <v-btn v-if="connected === true && timer > 0" @click="stopTracking()">Stop Tracking</v-btn>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <h2 class="title">Messwerte</h2>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <h3 class="subtitle-1">Geschwindigkeit</h3>
                                <p class="display-1">{{ averageWindSpeed }} m/s</p>
                            </v-col>
                            <v-col>
                                <h3 class="subtitle-1">Richtung</h3>
                                <p class="display-1">{{ averageWindDirection }} °</p>
                            </v-col>
                            <v-col>
                                <h3 class="subtitle-1">Temperatur</h3>
                                <p class="display-1">{{ lastTemperature }} °C</p>
                            </v-col>
                            <v-col>
                                <h3 class="subtitle-1">Batterie</h3>
                                <p class="display-1">{{ lastBatteryLevel }} %</p>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <v-sparkline
                                    :labels="this.averageWindSpeedValues"
                                    :value="this.averageWindSpeedValues"
                                    :auto-line-width="true"
                                type="bar"></v-sparkline>
                                </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="scanBluetoothDevices()">Scannen</v-btn>
                        <v-spacer></v-spacer>
                        <download-csv :data="getItemsCsv()">
                            <v-btn>Download</v-btn>
                        </download-csv>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>

    </div>
</template>

<script>
    import PureVueChart from 'pure-vue-chart';

    export default {
        name: 'home',
        components: {
            PureVueChart,
        },
        data() {
            return {
                options: {
                    acceptAllDevices: true,
                    optionalServices: [
                        'heart_rate'
                    ]
                },
                device: undefined,
                connecting: false,
                connected: false,
                server: undefined,
                date: [],
                gps: [],
                windSpeed: [],
                windDirection: [],
                timer: undefined,
                bluetoothCharacteristic: undefined,
                batteryLevel: [],
                temperature: [],
                valuesToCalculate: 6,
                intervalTime: 5
            }
        },
        computed: {
            averageWindSpeedValues() {
                return this.windSpeed.slice(this.valuesToCalculate * -1)
            },
            averageWindSpeed() {
                if (this.averageWindSpeedValues.length === this.valuesToCalculate) {
                    const sum = this.averageWindSpeedValues.reduce(function (a, b) {
                        return a + b;
                    });
                    return (sum / this.valuesToCalculate).toFixed(2);
                }

                return 0;
            },
            averageWindDirectionValues() {
                return this.windDirection.slice(this.valuesToCalculate * -1)
            },
            averageWindDirection() {
                if (this.averageWindDirectionValues.length === this.valuesToCalculate) {
                    const sum = this.averageWindDirectionValues.reduce(function (a, b) {
                        return a + b;
                    });
                    return (sum / this.valuesToCalculate).toFixed(0);
                }

                return 0;
            },
            lastTemperature () {
                if (this.temperature.length > 0) {
                    return this.temperature[this.temperature.length - 1];
                }

                return 0;
            },
            lastBatteryLevel () {
                if (this.batteryLevel.length > 0) {
                    return this.batteryLevel[this.batteryLevel.length - 1];
                }

                return 0;
            }
        },
        methods: {
            scanBluetoothDevices() {
                this.device = undefined;
                this.Navigator.bluetooth.requestDevice(this.options)
                    .then(device => {
                        this.device = device;
                        this.connect();
                    });
            },
            connect() {
                this.connecting = true;
                this.device.gatt.connect().then(server => {
                    this.connecting = false;
                    this.connected = server.connected;
                    this.server = server;
                    if (server.connected === true) {
                        server.getPrimaryService('heart_rate').then(service => {
                            service.getCharacteristic('heart_rate_control_point').then(characteristic => {
                                this.bluetoothCharacteristic = characteristic;
                                characteristic.readValue().then(value => {
                                    this.startTracking();
                                });
                            })
                        });
                    }
                }).catch(() => {
                    this.connecting = false;
                });
            },
            disconnect() {
                this.stopTracking();
                this.device.gatt.disconnect();
                this.connected = false;
            },
            startTracking() {
                this.timer = setInterval(() => {
                    if (this.connected === true && this.bluetoothCharacteristic !== undefined) {
                        this.bluetoothCharacteristic.readValue().then(value => {
                            this.addDate();
                            this.addWindSpeed(value.getUint16(0, true));
                            this.addWindDirection(value.getUint16(1));
                            this.addBatteryLevel(value.getUint8(4));
                            this.addTemperature(value.getUint8(5));
                            this.addGeolocation();
                        });
                    }
                }, this.intervalTime * 1000);
            },
            stopTracking() {
                this.bluetoothCharacteristic.stopNotifications();
                clearInterval(this.timer);
                this.timer = undefined
            },
            addDate() {
              this.date.push(new Date())  ;
            },
            addWindSpeed(value) {
                this.windSpeed.push(value / 100);
            },
            addWindDirection(value) {
                this.windDirection.push(value);
            },
            addTemperature(value) {
                this.temperature.push(value - 100);
            },
            addBatteryLevel(value) {
                this.batteryLevel.push(value * 10);
            },
            addGeolocation() {
                navigator.geolocation.getCurrentPosition(position => {
                    console.log(position);
                    this.gps.push(position);
                });
            },
            getItemsCsv () {
                let items = [];
                const itemsLength = this.windSpeed.length
                for (let i = 0; i < itemsLength; i++) {
                    items.push({
                        date: this.date[i],
                        speed: this.windSpeed[i],
                        direction: this.windDirection[i],
                        temperature: this.temperature[i],
                        batteryLevel: this.batteryLevel[i],
                        lat: this.gps[i].coords.latitude,
                        lng: this.gps[i].coords.longitude,
                    });
                }

                return items;
            }
        }
    }
</script>
